var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let RecordSelectSelectAllComponent = (_class = class RecordSelectSelectAllComponent extends Component {
  get indeterminate() {
    return this.args.selectedModels.length > 0 && this.args.selectedModels.length < this.args.models.length;
  }
  get checked() {
    return this.args.selectedModels.length > 0 && this.args.selectedModels.length === this.args.models.length;
  }
  handleChange(evt) {
    if (evt.target.checked) {
      this.args.onSelectAll();
    } else {
      this.args.onDeselectAll();
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype)), _class);
export { RecordSelectSelectAllComponent as default };